<script setup lang="ts">
// COMPOSABLES
const { tt } = useTypedI18n();

// DATA
const sections = computed(() => [
    {
        icon: 'fl:deal',
        title: tt('mktg.whyFleequid.deal.title'),
        description: tt('mktg.whyFleequid.deal.description'),
    },
    {
        icon: 'fl:processes',
        title: tt('mktg.whyFleequid.processes.title'),
        description: tt('mktg.whyFleequid.processes.description'),
    },
    {
        icon: 'fl:support',
        title: tt('mktg.whyFleequid.support.title'),
        description: tt('mktg.whyFleequid.support.description'),
    },
]);
</script>

<template>
    <div class="bg-primary-950 flex w-full justify-center">
        <BaseWidthContainer class="text-inverted flex flex-col gap-y-12 py-[60px]">
            <h4 class="text-2xl font-bold tracking-normal md:text-center md:text-4xl md:leading-10">
                {{ tt('mktg.whyFleequid.title') }}
            </h4>
            <div class="flex flex-col items-baseline gap-y-12 md:grid md:grid-cols-3 md:gap-x-6">
                <div v-for="(section, index) in sections" :key="index" class="flex flex-col justify-center gap-y-3 md:items-center md:text-center">
                    <div class="flex h-16 w-16 items-center justify-center rounded-full bg-white md:h-20 md:w-20 xl:h-24 xl:w-24">
                        <UIcon :name="section.icon" class="h-9 w-9 md:h-12 md:w-12 xl:h-16 xl:w-16" />
                    </div>
                    <p class="text-xl font-bold tracking-tighter">
                        {{ section.title }}
                    </p>
                    <p class="font-medium">
                        {{ section.description }}
                    </p>
                </div>
            </div>
        </BaseWidthContainer>
    </div>
</template>
